namespace GeniuzPOS.InitialData {
    export class PsSalesmanGroupColumns {
        static columnsKey = 'InitialData.PsSalesmanGroup';
    }
}
